import { render, staticRenderFns } from "./salesDetails.vue?vue&type=template&id=18f84166&scoped=true&"
import script from "./salesDetails.vue?vue&type=script&lang=js&"
export * from "./salesDetails.vue?vue&type=script&lang=js&"
import style0 from "./salesDetails.vue?vue&type=style&index=0&id=18f84166&scoped=true&lang=css&"
import style1 from "./salesDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f84166",
  null
  
)

export default component.exports